import React from 'react'

import classes from './AppraisalItemHeader.scss'
import CardHeader from '../../../UI/Card/Header/Header'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import { camelCase } from 'lodash'

const appraisalItemHeader = ({ companyData, translate }) => {
  let companyInfo = null
  if (companyData) {
    companyInfo = (
      <div className={classes.CompanyInfo}>
        <span className={classes.InfoItem}>
          <b>{translate(camelCase('Line Business'))}:</b> {companyData.business_line}
        </span>
        <span className={classes.InfoItem}>
          <b>{translate(camelCase('Company'))}:</b> {companyData.company_name}
        </span>
      </div>
    )
  }
  return <CardHeader title={companyInfo} disableTypography={true} />
}

export default withTranslate(appraisalItemHeader)
